var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.236 10.354h-.676v-.034H12v3.36h4.748A5.04 5.04 0 0 1 12 17.04 5.04 5.04 0 0 1 6.96 12 5.04 5.04 0 0 1 12 6.96c1.285 0 2.454.484 3.344 1.276l2.375-2.375A8.36 8.36 0 0 0 12 3.6 8.4 8.4 0 0 0 3.6 12a8.4 8.4 0 0 0 8.4 8.4 8.4 8.4 0 0 0 8.236-10.046",
    clipRule: "evenodd"
  })));
};
export default SvgGoogle;